module.exports = __webpack_public_path__ + "static/media/video-cover.5bb4fa25.jpg";